/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * PHRMPC.Manning.Web.API | v1
 * OpenAPI spec version: 1.0.0
 */
import { z as zod } from 'zod';

export const ApproveScheduleSiteChangeRequest = zod.object({
  "id": zod.string().uuid().optional(),
  "supervisorRemarks": zod.string().nullish()
});

export type ApproveScheduleSiteChangeRequest = zod.input<typeof ApproveScheduleSiteChangeRequest>;
export type ApproveScheduleSiteChangeRequestOutput = zod.output<typeof ApproveScheduleSiteChangeRequest>;
